import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import dayjs from 'dayjs';

export default {
  props: {
    show: {
      type: Boolean,
    },
  },
  components: {},
  data() {
    return {
      dialogVisible: false,
      signForm: {
        password: '',
        key: '',
        caAdress: ''
      },
      signerInfo: null,
      loading: false,
      signFormRules: {
        password: [
          {
            required: true,
            message: "Поле обов'язкове до заповнення",
            trigger: 'blur',
          },
        ],
        key: [
          {
            validator: (rule, value, callback) => {
              var _validFileExtensions = [
                '.dat',
                '.pfx',
                '.pk8',
                '.zs2',
                '.jks',
              ];
              if (value === '') {
                callback(
                  new Error(
                    'Оберіть особистий ключ в форматі: key-6.dat, *.pfx, *.pk8, *.zs2 або *.jks'
                  )
                );
              } else if (!this.hasExtension(value.name, _validFileExtensions)) {
                callback(
                  new Error(
                    'Ключ повинний бути в форматі: key-6.dat, *.pfx, *.pk8, *.zs2 або *.jks'
                  )
                );
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
    };
  },
  watch: {
    show(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit('update:show', val);
      }
    },
  },
  beforeMount() {
    this.getCaList();
  },
  computed: {
    ...mapState({
      eisCode: (state) => state.Applications.application.eisCode,
      applicationBlob: (state) => state.Applications.applicationBlob,
      caList: (state) => state.Applications.cAList,
    }),
    certDateValid() {
      return dayjs().isBefore(dayjs(this.signerInfo.valid.to))
    }
  },
  methods: {
    ...mapActions(['setSignedApplicationBlob', 'getCaList']),
    onKeyUploaderChange(file) {
      this.signForm.key = file.raw;
    },
    readKey() {
      this.$refs.signForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let formData = new FormData();
          formData.append('eisCode', this.eisCode);
          formData.append('file', this.signForm.key);
          formData.append('password', this.signForm.password);
          formData.append('host', `http://${this.signForm.caAdress}`);
          axios
            .post('/api/application/get-certificate', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then((resp) => {
              this.signerInfo = { ...resp.data.signerInfo, ...resp.data.certInfo, };
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }

      });
    },
    signDocument() {
      this.$refs.signForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let formData = new FormData();
          formData.append('eisCode', this.eisCode);
          formData.append('file', this.signForm.key);
          formData.append('password', this.signForm.password);
          formData.append(
            'applicationFile',
            new File([this.applicationBlob], 'Заява_Приєднання.pdf', {
              type: 'application/pdf',
            })
          );
          axios
            .post('/api/application/sign-document', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then((resp) => {
              this.$notify.success({
                title: 'Вітаємо!',
                message: resp.data.message,
              });
              this.$refs.signForm.resetFields();
              this.signerInfo = null;
              this.signForm.key = '';
              this.dialogVisible = false;
              const signedApplicationBlob = new Blob(
                [new Uint8Array(resp.data.signedApplication.data).buffer]
              );
              this.setSignedApplicationBlob(signedApplicationBlob);
              this.$emit('on-sign');
              this.loading = false;
            })
            .catch((err) => {
              this.$notify.error({
                title: 'Помилка!',
                message: err.response.data,
              });
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    getExpirationDate() {
      return `${dayjs(this.signerInfo.valid.from).format('DD-MM-YYYY')} - ${dayjs(this.signerInfo.valid.to).format('DD-MM-YYYY')}`;
    },
    hasExtension(fileName, exts) {
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      );
    },
  },
};
